/*
 * Get-cart.ts
 * Description: Includes the declaration
 * of function for getting all items in a cart
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing uuid
import uuidv1 from 'uuid/v1';

/**
 * Getting items from the cart
 *
 * @return {Object} Promise - list of items in the cart
 * @param {String} slug - id of the restaurant
 * @param {String} coupon- coupon code
 */
export function getCart(slug: string, coupon: string = '') {
    const jwt = localStorage.getItem('jwt');
    if (localStorage.getItem(slug) === null) {
        // Creating a unique id so that every
        // cart will have a different number
        const key = uuidv1();
        localStorage.setItem(slug, key);
    }
    const id = localStorage.getItem(slug);
    // Creating a new instance of Promise to make JavaScript work synchronous
    return new Promise ((resolve, reject) => {
        // Creating an HTTP request to refresh jwt token
        Axios({
            url:  APIURL + 'carts',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            params: {
                guest_id: id,
                coupon,
            },
            data: {},
        }).then((response) => {
            resolve(response.data);
        }).catch(() => {
            reject();
        });
    });
}
